var map = {
	"./en-US/agent/1_introduce.json": "CM7q",
	"./en-US/agent/api/agent/01_get_Query_Invited_Users.json": "Bd4q",
	"./en-US/agent/api/agent/02_get_Daily_Commission_Query.json": "Czkf",
	"./en-US/agent/api/agent/03_get_Query_agent_user_nformation.json": "N9hH",
	"./en-US/agent/api/agent/04_get_Query_the_deposit_details.json": "ZKxt",
	"./en-US/agent/api/agent/05_get_Query_API_transaction_commission.json": "mYC+",
	"./en-US/agent/api/agent/06_get_Query_partner_information.json": "sHlI",
	"./en-US/agent/api/agent/07_get_referral_code_commission.json": "OWE/",
	"./en-US/agent/api/agent/08_get_Query_agent_superior_check.json": "aK5B",
	"./en-US/authentication/01_create_api.json": "+Rge",
	"./en-US/authentication/02_permission_set.json": "UG8z",
	"./en-US/authentication/03_request_content.json": "hS6o",
	"./en-US/authentication/04_sign_discription.json": "9KKA",
	"./en-US/authentication/05_request.json": "uSYo",
	"./en-US/changelog/2023-06-03.json": "/bR7",
	"./en-US/changelog/2023-07-29.json": "IOcs",
	"./en-US/changelog/2023-08-03.json": "H0k7",
	"./en-US/changelog/2023-08-11.json": "D1C9",
	"./en-US/changelog/2023-08-23.json": "CcT1",
	"./en-US/changelog/2023-09-18.json": "v1XT",
	"./en-US/changelog/2023-10-12.json": "7wfK",
	"./en-US/changelog/2023-11-10.json": "U8SU",
	"./en-US/changelog/2023-11-22.json": "4w61",
	"./en-US/changelog/2023-12-08.json": "aUA7",
	"./en-US/changelog/2023-12-21.json": "R2wc",
	"./en-US/changelog/2024-01-10.json": "k/At",
	"./en-US/changelog/2024-01-23.json": "FtO6",
	"./en-US/changelog/2024-02-04.json": "sMHE",
	"./en-US/changelog/2024-02-23.json": "nFKt",
	"./en-US/changelog/2024-03-04.json": "VZgP",
	"./en-US/changelog/2024-03-14.json": "UMYu",
	"./en-US/changelog/2024-03-19.json": "68aw",
	"./en-US/changelog/2024-03-28.json": "96CF",
	"./en-US/changelog/2024-04-15.json": "eP5L",
	"./en-US/changelog/2024-04-25.json": "0uHt",
	"./en-US/changelog/2024-05-23.json": "wQ5t",
	"./en-US/changelog/2024-05-27.json": "ED08",
	"./en-US/changelog/2024-06-13.json": "Jim+",
	"./en-US/changelog/2024-06-28.json": "xM8g",
	"./en-US/changelog/2024-07-11.json": "vZQv",
	"./en-US/changelog/2024-07-22.json": "OOYK",
	"./en-US/changelog/2024-07-30.json": "OTiI",
	"./en-US/changelog/2024-08-08.json": "dzxx",
	"./en-US/changelog/2024-08-17.json": "jPZq",
	"./en-US/changelog/2024-08-22.json": "POz2",
	"./en-US/changelog/2024-08-27.json": "gYbm",
	"./en-US/changelog/2024-09-11.json": "Lezn",
	"./en-US/changelog/2024-09-23.json": "6qxj",
	"./en-US/changelog/2024-10-09.json": "esMP",
	"./en-US/changelog/2024-10-11.json": "McI3",
	"./en-US/changelog/2024-10-16.json": "OleB",
	"./en-US/changelog/2024-10-23.json": "pxxT",
	"./en-US/changelog/2024-10-24.json": "SHTI",
	"./en-US/changelog/2024-10-30.json": "Gmgm",
	"./en-US/changelog/2024-11-07.json": "1koR",
	"./en-US/changelog/2024-11-08.json": "Np/o",
	"./en-US/changelog/2024-11-15.json": "yLee",
	"./en-US/changelog/2024-11-19.json": "Jf4T",
	"./en-US/changelog/2024-12-06.json": "2XCm",
	"./en-US/changelog/2024-12-17.json": "DOPU",
	"./en-US/changelog/2025-01-21.json": "/m37",
	"./en-US/changelog/2025-01-22.json": "kUTM",
	"./en-US/changelog/2025-02-10.json": "rMBC",
	"./en-US/changelog/2025-03-13.json": "MNmP",
	"./en-US/changelog/2025-04-25.json": "pNhc",
	"./en-US/changelog/2025-05-14.json": "MrPT",
	"./en-US/changelog/2025-06-12.json": "I6Rl",
	"./en-US/changelog/2025-06-17.json": "XMQV",
	"./en-US/changelog/2025-06-30.json": "EwTG",
	"./en-US/changelog/2025-07-09.json": "FF3k",
	"./en-US/changelog/2025-07-11.json": "+rRL",
	"./en-US/changelog/2025-08-21.json": "693+",
	"./en-US/changelog/2025-09-01.json": "JH82",
	"./en-US/changelog/2025-09-10.json": "aYNr",
	"./en-US/changelog/2025-10-09.json": "AxcT",
	"./en-US/changelog/2025-10-11.json": "MCA4",
	"./en-US/changelog/2025-11-13.json": "hdtI",
	"./en-US/changelog/2025-11-25.json": "ureo",
	"./en-US/changelog/2025-12-09.json": "E7ys",
	"./en-US/changelog/2025-12-16.json": "c8/f",
	"./en-US/changelog/2025-12-18.json": "sqvz",
	"./en-US/changelog/2026-01-05.json": "AUPB",
	"./en-US/changelog/2026-01-22.json": "38eu",
	"./en-US/common/1_introduce.json": "puzn",
	"./en-US/common/api/permission/01_get_account_apiRestrictions.json": "Xu0+",
	"./en-US/common/api/subAccount/01_create_sub_accuont.json": "+6hF",
	"./en-US/common/api/subAccount/02_get_account_apiPermission.json": "vPcu",
	"./en-US/common/api/subAccount/02_post_fetch_uid.json": "xx9R",
	"./en-US/common/api/subAccount/03_post_fetch_sub_account_list.json": "uuPR",
	"./en-US/common/api/subAccount/04_get_sub_account_spot_balance.json": "PVSb",
	"./en-US/common/api/subAccount/05_create_sub_accuont_key.json": "eSSt",
	"./en-US/common/api/subAccount/06_get_api_key_info.json": "MQqI",
	"./en-US/common/api/subAccount/07_post_edit_apikey.json": "Jwag",
	"./en-US/common/api/subAccount/08_delete_sub_account_key.json": "J2bY",
	"./en-US/common/api/subAccount/09_update_sub_account_status.json": "nHln",
	"./en-US/common/api/subAccount/10.post_wallet_authorize_innerTransfer.json": "HQ8m",
	"./en-US/common/api/subAccount/11.post_wallet_subInnerTransfer.json": "+W0b",
	"./en-US/common/api/subAccount/11_post_capital_innerTransfer_apply.json": "4v69",
	"./en-US/common/api/subAccount/12.post_wallet_createSubDepositAddress.json": "33ms",
	"./en-US/common/api/subAccount/15.get_wallet_querySubDepositAddress.json": "zfQA",
	"./en-US/common/api/subAccount/16.get_wallet_querySubDepositRecords.json": "cjvr",
	"./en-US/common/api/subAccount/17.get_wallet_querySubInnerTransferRecords.json": "FRId",
	"./en-US/common/api/subAccount/18.query_sub_account_transfer_history.json": "Jxen",
	"./en-US/common/api/subAccount/19.sub_account_transfer_support_coin.json": "A6qi",
	"./en-US/common/api/subAccount/20.sub_account_transfer.json": "6Epj",
	"./en-US/common/api/subAccount/22_sub_account_allAccountBalance.json": "aaNH",
	"./en-US/copyTrade/1_introduce.json": "yyuB",
	"./en-US/copyTrade/api/pFuturesTrader/01_get_currentTrack.json": "lgiQ",
	"./en-US/copyTrade/api/pFuturesTrader/02_post_close_currentTrack.json": "TSOU",
	"./en-US/copyTrade/api/pFuturesTrader/03_post_tpsl_currentTrack.json": "UWbd",
	"./en-US/copyTrade/api/pFuturesTrader/05_swap_trader_detail.json": "ds0K",
	"./en-US/copyTrade/api/pFuturesTrader/06_swap_trader_profit_summary.json": "4DDS",
	"./en-US/copyTrade/api/pFuturesTrader/07_swap_trader_profit_detail.json": "eNxZ",
	"./en-US/copyTrade/api/pFuturesTrader/08_swap_trader_set_commission.json": "7lDL",
	"./en-US/copyTrade/api/pFuturesTrader/09_swap_trader_trading_pair.json": "fvxU",
	"./en-US/copyTrade/api/spotTrader/04_spot_trader_sell_order.json": "Zis6",
	"./en-US/copyTrade/api/spotTrader/10_spot_trader_detail.json": "Zgby",
	"./en-US/copyTrade/api/spotTrader/11_spot_trader_profit_summary.json": "sfhW",
	"./en-US/copyTrade/api/spotTrader/12_spot_trader_profit_detail.json": "2mJN",
	"./en-US/copyTrade/api/spotTrader/13_spot_trader_order_history.json": "3wC1",
	"./en-US/cswap/1_introduce.json": "omwE",
	"./en-US/cswap/2_description.json": "WXeB",
	"./en-US/cswap/api/basic/01_error_code.json": "Py8D",
	"./en-US/cswap/api/basic/02_timestamp.json": "Ui1f",
	"./en-US/cswap/api/basic/03_digital_rule.json": "OGaA",
	"./en-US/cswap/api/basic/04_rate_limits.json": "dz5L",
	"./en-US/cswap/api/basic/05_system_time.json": "TbUJ",
	"./en-US/cswap/api/market/01_get_contracts.json": "Fui1",
	"./en-US/cswap/api/market/02_get_premiumIndex.json": "5uda",
	"./en-US/cswap/api/market/03_get_openInterest.json": "ewcP",
	"./en-US/cswap/api/market/04_get_kline.json": "FuQd",
	"./en-US/cswap/api/market/05_get_depth.json": "GbOE",
	"./en-US/cswap/api/market/06_get_ticker.json": "6xac",
	"./en-US/cswap/api/trade/00_post_trade_order.json": "JG85",
	"./en-US/cswap/api/trade/01_get_commissionRate.json": "3Csz",
	"./en-US/cswap/api/trade/01_get_leverage.json": "6Wqe",
	"./en-US/cswap/api/trade/03_post_leverage.json": "HWdZ",
	"./en-US/cswap/api/trade/04_post_allOpenOrders.json": "xM9z",
	"./en-US/cswap/api/trade/05_post_closeAllPositions.json": "A11g",
	"./en-US/cswap/api/trade/06_get_positions.json": "Uqg4",
	"./en-US/cswap/api/trade/07_get_balance.json": "DyCG",
	"./en-US/cswap/api/trade/08_get_forceOrders.json": "79Xw",
	"./en-US/cswap/api/trade/09_get_allFillOrders.json": "KXGF",
	"./en-US/cswap/api/trade/10_delete_trade_order.json": "Mwlf",
	"./en-US/cswap/api/trade/11_get_all_openOrders.json": "Ui0Y",
	"./en-US/cswap/api/trade/12_get_trade_order.json": "nj2w",
	"./en-US/cswap/api/trade/14_get_trade_allOrders.json": "BW7b",
	"./en-US/cswap/api/trade/15_get_margin_type.json": "Qb5x",
	"./en-US/cswap/api/trade/16_post_margin_type.json": "dI3A",
	"./en-US/cswap/api/trade/17_post_trade_positionMargin.json": "2WEb",
	"./en-US/cswap/websocket/account/01_balance.json": "bzx+",
	"./en-US/cswap/websocket/account/02_order.json": "K1eD",
	"./en-US/cswap/websocket/account/03_setting.json": "2Cei",
	"./en-US/cswap/websocket/introduce/01_connect.json": "lyY+",
	"./en-US/cswap/websocket/introduce/02_data_compress.json": "Q5Jp",
	"./en-US/cswap/websocket/introduce/03_heart_beat.json": "IMXD",
	"./en-US/cswap/websocket/introduce/04_subscribe.json": "rEmz",
	"./en-US/cswap/websocket/introduce/05_cancel_subscribe.json": "SBKE",
	"./en-US/cswap/websocket/market/01_trade_info.json": "dF/+",
	"./en-US/cswap/websocket/market/02_last_price.json": "GtO6",
	"./en-US/cswap/websocket/market/03_mark_price.json": "BwZb",
	"./en-US/cswap/websocket/market/04_depth.json": "fcau",
	"./en-US/cswap/websocket/market/05_bookTicker.json": "KrjX",
	"./en-US/cswap/websocket/market/06_kline.json": "sLxw",
	"./en-US/cswap/websocket/market/07_24hr_ticker.json": "ywsQ",
	"./en-US/listenKey/01_create_listenKey.json": "8kVO",
	"./en-US/listenKey/02_put_listenKey.json": "Rtfu",
	"./en-US/listenKey/03_delete_listenKey.json": "LvyQ",
	"./en-US/q&a/2023-09-12.json": "WisP",
	"./en-US/spot/1_introduce.json": "y1S6",
	"./en-US/spot/api/account/00_get_account_balance.json": "HY4c",
	"./en-US/spot/api/account/02_get_asset_transfer2.json": "gp5h",
	"./en-US/spot/api/account/07_post_capital_innerTransfer_apply.json": "KPNz",
	"./en-US/spot/api/account/08_post_asset_transfer_new.json": "kbpg",
	"./en-US/spot/api/account/09_get_account_transfer_support_coin.json": "IyO2",
	"./en-US/spot/api/account/10_get_asset_transfer_record.json": "oyKG",
	"./en-US/spot/api/account/11_get_fund_account_balance.json": "5M3S",
	"./en-US/spot/api/account/14.get_wallet_queryInnerTransferRecords.json": "9tS2",
	"./en-US/spot/api/account/21_get_account_allAccountBalance.json": "Exaw",
	"./en-US/spot/api/basic/01_server_url.json": "wWlE",
	"./en-US/spot/api/basic/03_error_code.json": "/sx7",
	"./en-US/spot/api/basic/04_rate_limits.json": "bIsO",
	"./en-US/spot/api/basic/04_server_url.json": "GK5R",
	"./en-US/spot/api/market/01_get_common_symbols.json": "qHSP",
	"./en-US/spot/api/market/02_get_ market_traders.json": "u7QQ",
	"./en-US/spot/api/market/03_get_market_depth.json": "xaTv",
	"./en-US/spot/api/market/04_get_market_klines.json": "l6fp",
	"./en-US/spot/api/market/05_get_quote_ticker.json": "mWiW",
	"./en-US/spot/api/market/06_get_market_agg_depth.json": "eCwL",
	"./en-US/spot/api/market/07_get_market_price.json": "p4oz",
	"./en-US/spot/api/market/08_get_market_book_ticker.json": "OdvA",
	"./en-US/spot/api/market/09_get_market_history_klines.json": "Turq",
	"./en-US/spot/api/market/10_get_ market_histroy_traders.json": "MGWO",
	"./en-US/spot/api/trade/01_post_trade_a_order.json": "ZnNv",
	"./en-US/spot/api/trade/01_post_trade_batchOrders.json": "pX3/",
	"./en-US/spot/api/trade/021_post_trade_order_cancel.json": "ev9X",
	"./en-US/spot/api/trade/022_post_trade_orders_cancel.json": "aTY/",
	"./en-US/spot/api/trade/023_post_cancelOpenOrders.json": "gz1R",
	"./en-US/spot/api/trade/023_post_trade_order_cancel_replace.json": "TA5G",
	"./en-US/spot/api/trade/03_get_trade_order.json": "EDR3",
	"./en-US/spot/api/trade/04_get_trade_open_order.json": "V7qZ",
	"./en-US/spot/api/trade/05_get_trade_history_order.json": "s6dj",
	"./en-US/spot/api/trade/077_get_trade_fill_details.json": "s+Dd",
	"./en-US/spot/api/trade/08_get_commissionRate.json": "sPli",
	"./en-US/spot/api/trade/09_cancel_all_after.json": "KWsz",
	"./en-US/spot/api/trade/100_post_one_oco_order.json": "R/1P",
	"./en-US/spot/api/trade/101_cancel_one_oco_order.json": "dd2V",
	"./en-US/spot/api/trade/102_get_one_oco_order.json": "MN46",
	"./en-US/spot/api/trade/103_get_all_pending_oco_order.json": "YC1x",
	"./en-US/spot/api/trade/104_get_all_history_oco_order.json": "JLQZ",
	"./en-US/spot/api/wallet/03_get_deposit_hisrec.json": "dXH3",
	"./en-US/spot/api/wallet/04_get_withdraw_history.json": "kh23",
	"./en-US/spot/api/wallet/05_post_wallets_coins.json": "zgmp",
	"./en-US/spot/api/wallet/06_post_wallets_withdraw.json": "YSKw",
	"./en-US/spot/api/wallet/13.get_wallet_queryDepositAddress.json": "rgh9",
	"./en-US/spot/api/wallet/14_get_risk_deposit_records.json": "CxZu",
	"./en-US/spot/websocket/account/01_executionReport.json": "pjpR",
	"./en-US/spot/websocket/account/02_ account_update.json": "5y10",
	"./en-US/spot/websocket/introduce/01_limit.json": "+dFG",
	"./en-US/spot/websocket/introduce/02_connect.json": "hDC3",
	"./en-US/spot/websocket/introduce/03_data_compress.json": "YUWz",
	"./en-US/spot/websocket/introduce/04_heart_beat.json": "Ze9p",
	"./en-US/spot/websocket/introduce/05_cancel_subscribe.json": "hlb8",
	"./en-US/spot/websocket/introduce/06_subscribe.json": "g2tG",
	"./en-US/spot/websocket/market/01_trade_info.json": "jcbY",
	"./en-US/spot/websocket/market/02_kline_data.json": "3EGE",
	"./en-US/spot/websocket/market/03_depth_info.json": "fsqo",
	"./en-US/spot/websocket/market/04_24hr_ticker.json": "P0Vd",
	"./en-US/spot/websocket/market/05_last_price.json": "fqiK",
	"./en-US/spot/websocket/market/06_book_ticker.json": "o9Mz",
	"./en-US/spot/websocket/market/07_depth_incr_info.json": "soQQ",
	"./en-US/standard/1_introduce.json": "HGsQ",
	"./en-US/standard/api/trade/01_get_contract_allPosition.json": "ttu5",
	"./en-US/standard/api/trade/02_get_contract_allOrders.json": "RhU9",
	"./en-US/standard/api/trade/03_get_contract_balance.json": "n0S/",
	"./en-US/swapV2/1_introduce.json": "goAe",
	"./en-US/swapV2/2_description.json": "5MML",
	"./en-US/swapV2/api/account/01_get_user_balance.json": "W4Cx",
	"./en-US/swapV2/api/account/02_get_user_positions.json": "mp7j",
	"./en-US/swapV2/api/account/03_get_user_income.json": "h0vl",
	"./en-US/swapV2/api/account/18_get_trade_income_export.json": "/Pe4",
	"./en-US/swapV2/api/account/19_get_trade_user_commissionRate.json": "v5LS",
	"./en-US/swapV2/api/basic/01_error_code.json": "+lFy",
	"./en-US/swapV2/api/basic/02_timestamp.json": "VQr5",
	"./en-US/swapV2/api/basic/03_digital_rule.json": "C2jk",
	"./en-US/swapV2/api/basic/04_rate_limits.json": "nG30",
	"./en-US/swapV2/api/basic/05_system_time.json": "zNUa",
	"./en-US/swapV2/api/market/01_get_quote_contracts.json": "DcMO",
	"./en-US/swapV2/api/market/03_get_quote_depth.json": "e+0O",
	"./en-US/swapV2/api/market/04_get_quote_ trades.json": "PqB/",
	"./en-US/swapV2/api/market/05_get_quote_ premiumIndex.json": "Tk4L",
	"./en-US/swapV2/api/market/06_get_quote_ fundingRate.json": "YtyA",
	"./en-US/swapV2/api/market/07_get_quote_ klines.json": "xU+M",
	"./en-US/swapV2/api/market/08_get_quote_openInterest.json": "j4uq",
	"./en-US/swapV2/api/market/09_get_quote_ ticker.json": "LWb5",
	"./en-US/swapV2/api/market/19_get_historicalTrades.json": "xyiP",
	"./en-US/swapV2/api/market/20_get_trade_quote_bookTicker.json": "E4EJ",
	"./en-US/swapV2/api/market/21_get_quote_mark_price_klines.json": "VeQG",
	"./en-US/swapV2/api/market/22_get_quote_price_v2.json": "rCcB",
	"./en-US/swapV2/api/market/23_get_trading_rules.json": "fKSd",
	"./en-US/swapV2/api/trade/00_post_trade_order_test.json": "TrnZ",
	"./en-US/swapV2/api/trade/01_post_trade_order.json": "YLkf",
	"./en-US/swapV2/api/trade/01_post_trade_order_vst.json": "dww0",
	"./en-US/swapV2/api/trade/02_post_edit_order.json": "plpn",
	"./en-US/swapV2/api/trade/02_post_trade_batch_order.json": "/bqr",
	"./en-US/swapV2/api/trade/03_post_closeAllPositions.json": "jBL/",
	"./en-US/swapV2/api/trade/04_delete_trade_order.json": "nf3C",
	"./en-US/swapV2/api/trade/05_delete_trade_batch_order.json": "siG2",
	"./en-US/swapV2/api/trade/06_delete_trade_all_order.json": "/Fs7",
	"./en-US/swapV2/api/trade/07_get_all_openOrders.json": "jxdV",
	"./en-US/swapV2/api/trade/08_check_pending_order.json": "fLAw",
	"./en-US/swapV2/api/trade/08_get_trade_order.json": "1xud",
	"./en-US/swapV2/api/trade/09_get_trade_marginType.json": "Qa4f",
	"./en-US/swapV2/api/trade/10_post_trade_marginType.json": "WCFx",
	"./en-US/swapV2/api/trade/11_get_trade_leverage.json": "Nux4",
	"./en-US/swapV2/api/trade/12_post_trade_leverage.json": "j3Xb",
	"./en-US/swapV2/api/trade/13_get_trade_forceOrders.json": "fUN5",
	"./en-US/swapV2/api/trade/14_get_trade_allOrders.json": "iu9b",
	"./en-US/swapV2/api/trade/15_post_trade_positionMargin.json": "i3k4",
	"./en-US/swapV2/api/trade/17_get_trade_allFillOrders.json": "1A8u",
	"./en-US/swapV2/api/trade/18_set_positionSide.json": "wp4b",
	"./en-US/swapV2/api/trade/19_get_positionSide.json": "n7WW",
	"./en-US/swapV2/api/trade/20_cancel_replace_order.json": "vKvg",
	"./en-US/swapV2/api/trade/21_batch_cancel_replace_order.json": "nNrq",
	"./en-US/swapV2/api/trade/22_cancel_all_after.json": "6Ivy",
	"./en-US/swapV2/api/trade/22_post_closePosition.json": "JRrP",
	"./en-US/swapV2/api/trade/23_get_trade_allOrdersV2.json": "wYbs",
	"./en-US/swapV2/api/trade/24_get_maint_margin_ratio.json": "OkoV",
	"./en-US/swapV2/api/trade/25_get_fill_history_detail.json": "l3pU",
	"./en-US/swapV2/api/trade/26_get_user_position_history.json": "xptQ",
	"./en-US/swapV2/api/trade/27_get_position_margin_history.json": "bHz9",
	"./en-US/swapV2/api/trade/27_post_get_vst.json": "cn9g",
	"./en-US/swapV2/api/trade/28_post_twap_order.json": "6+7u",
	"./en-US/swapV2/api/trade/29_get_twap_open_orders.json": "2vkv",
	"./en-US/swapV2/api/trade/30_get_twap_history_orders.json": "BBsp",
	"./en-US/swapV2/api/trade/31_get_twap_order_detail.json": "NQ2q",
	"./en-US/swapV2/api/trade/32_cancel_twap_cancel_order.json": "iXtv",
	"./en-US/swapV2/api/trade/33_post_asset_mode.json": "xS3w",
	"./en-US/swapV2/api/trade/34_get_asset_mode.json": "ZFUX",
	"./en-US/swapV2/api/trade/35_get_multi_asset_rule.json": "jifI",
	"./en-US/swapV2/api/trade/36_get_margin_asset.json": "+eKI",
	"./en-US/swapV2/api/trade/37_post_trade_reverse.json": "0tet",
	"./en-US/swapV2/api/trade/38_post_auto_add_margin.json": "PWIR",
	"./en-US/swapV2/websocket/account/01_listenKey.json": "gOrG",
	"./en-US/swapV2/websocket/account/02_balance.json": "Zg2x",
	"./en-US/swapV2/websocket/account/03_order.json": "4X8p",
	"./en-US/swapV2/websocket/account/04_setting.json": "M7Po",
	"./en-US/swapV2/websocket/introduce/00_limit.json": "/ur1",
	"./en-US/swapV2/websocket/introduce/01_connect.json": "wa9k",
	"./en-US/swapV2/websocket/introduce/02_data_compress.json": "vuQY",
	"./en-US/swapV2/websocket/introduce/03_heart_beat.json": "il07",
	"./en-US/swapV2/websocket/introduce/04_subscribe.json": "n8XW",
	"./en-US/swapV2/websocket/introduce/05_cancel_subscribe.json": "7k03",
	"./en-US/swapV2/websocket/market/01_dept_info_interval.json": "0EuA",
	"./en-US/swapV2/websocket/market/02_latest_records.json": "4L7x",
	"./en-US/swapV2/websocket/market/03_kline_data.json": "zKQU",
	"./en-US/swapV2/websocket/market/04_quote_ticker.json": "xVTF",
	"./en-US/swapV2/websocket/market/05_last_trade_price.json": "gvF4",
	"./en-US/swapV2/websocket/market/06_last_mark_price.json": "pgER",
	"./en-US/swapV2/websocket/market/07_book_ticker.json": "wF+v",
	"./en-US/swapV2/websocket/market/08_depth_incr_info.json": "hH3F",
	"./zh-tw/agent/1_introduce.json": "Nfjq",
	"./zh-tw/agent/api/agent/01_get_Query_Invited_Users.json": "zsZ4",
	"./zh-tw/agent/api/agent/02_get_Daily_Commission_Query.json": "Gwkw",
	"./zh-tw/agent/api/agent/03_get_Query_agent_user_nformation.json": "P9RC",
	"./zh-tw/agent/api/agent/04_get_Query_the_deposit_details.json": "7XUQ",
	"./zh-tw/agent/api/agent/05_get_Query_API_transaction_commission.json": "IoyB",
	"./zh-tw/agent/api/agent/06_get_Query_partner_information.json": "8au9",
	"./zh-tw/agent/api/agent/07_get_referral_code_commission.json": "ZspE",
	"./zh-tw/agent/api/agent/08_get_Query_agent_superior_check.json": "YnmZ",
	"./zh-tw/authentication/01_create_api.json": "uqo+",
	"./zh-tw/authentication/02_permission_set.json": "U3vK",
	"./zh-tw/authentication/03_request_content.json": "HVe5",
	"./zh-tw/authentication/04_sign_discription.json": "huDF",
	"./zh-tw/authentication/05_request.json": "2oJ6",
	"./zh-tw/changelog/2023-06-03.json": "jVl+",
	"./zh-tw/changelog/2023-07-29.json": "MfXY",
	"./zh-tw/changelog/2023-08-03.json": "9HpD",
	"./zh-tw/changelog/2023-08-11.json": "pV/D",
	"./zh-tw/changelog/2023-08-23.json": "bKtD",
	"./zh-tw/changelog/2023-09-18.json": "a/u1",
	"./zh-tw/changelog/2023-10-12.json": "DJaF",
	"./zh-tw/changelog/2023-11-10.json": "bGx6",
	"./zh-tw/changelog/2023-11-22.json": "axDH",
	"./zh-tw/changelog/2023-12-08.json": "+29D",
	"./zh-tw/changelog/2023-12-21.json": "CpXJ",
	"./zh-tw/changelog/2024-01-10.json": "KYMz",
	"./zh-tw/changelog/2024-01-23.json": "G8cI",
	"./zh-tw/changelog/2024-02-04.json": "NFKy",
	"./zh-tw/changelog/2024-02-23.json": "NuRj",
	"./zh-tw/changelog/2024-03-04.json": "3c71",
	"./zh-tw/changelog/2024-03-14.json": "Jip9",
	"./zh-tw/changelog/2024-03-19.json": "j7dp",
	"./zh-tw/changelog/2024-03-28.json": "ZNZv",
	"./zh-tw/changelog/2024-04-15.json": "i/xj",
	"./zh-tw/changelog/2024-04-25.json": "87c6",
	"./zh-tw/changelog/2024-05-23.json": "KSJz",
	"./zh-tw/changelog/2024-05-27.json": "5LYy",
	"./zh-tw/changelog/2024-06-13.json": "vBmL",
	"./zh-tw/changelog/2024-06-28.json": "khDw",
	"./zh-tw/changelog/2024-07-11.json": "vGFC",
	"./zh-tw/changelog/2024-07-22.json": "/chU",
	"./zh-tw/changelog/2024-07-30.json": "l7kI",
	"./zh-tw/changelog/2024-08-08.json": "F1dE",
	"./zh-tw/changelog/2024-08-17.json": "aG00",
	"./zh-tw/changelog/2024-08-22.json": "L5DY",
	"./zh-tw/changelog/2024-08-27.json": "TvGs",
	"./zh-tw/changelog/2024-09-11.json": "EMrv",
	"./zh-tw/changelog/2024-09-23.json": "nNlN",
	"./zh-tw/changelog/2024-10-09.json": "zB9+",
	"./zh-tw/changelog/2024-10-11.json": "ss+C",
	"./zh-tw/changelog/2024-10-16.json": "UDLl",
	"./zh-tw/changelog/2024-10-23.json": "nC6P",
	"./zh-tw/changelog/2024-10-24.json": "Aw6+",
	"./zh-tw/changelog/2024-10-30.json": "J9sz",
	"./zh-tw/changelog/2024-11-07.json": "R99K",
	"./zh-tw/changelog/2024-11-08.json": "htuQ",
	"./zh-tw/changelog/2024-11-15.json": "aAh/",
	"./zh-tw/changelog/2024-11-19.json": "wh3A",
	"./zh-tw/changelog/2024-12-06.json": "JseK",
	"./zh-tw/changelog/2024-12-17.json": "bLnD",
	"./zh-tw/changelog/2025-01-21.json": "GWmm",
	"./zh-tw/changelog/2025-01-22.json": "g2de",
	"./zh-tw/changelog/2025-02-10.json": "lKCo",
	"./zh-tw/changelog/2025-03-13.json": "j73g",
	"./zh-tw/changelog/2025-04-25.json": "CBF0",
	"./zh-tw/changelog/2025-05-14.json": "G4iE",
	"./zh-tw/changelog/2025-06-12.json": "BVW9",
	"./zh-tw/changelog/2025-06-17.json": "yMtp",
	"./zh-tw/changelog/2025-06-30.json": "qi3T",
	"./zh-tw/changelog/2025-07-09.json": "k7fq",
	"./zh-tw/changelog/2025-07-11.json": "Di8Z",
	"./zh-tw/changelog/2025-08-21.json": "ZXEx",
	"./zh-tw/changelog/2025-09-01.json": "w96y",
	"./zh-tw/changelog/2025-09-10.json": "erks",
	"./zh-tw/changelog/2025-10-09.json": "8erW",
	"./zh-tw/changelog/2025-10-11.json": "uWtu",
	"./zh-tw/changelog/2025-11-13.json": "xZQU",
	"./zh-tw/changelog/2025-11-25.json": "h/Yp",
	"./zh-tw/changelog/2025-12-09.json": "1/6l",
	"./zh-tw/changelog/2025-12-16.json": "fgRV",
	"./zh-tw/changelog/2025-12-18.json": "4myO",
	"./zh-tw/changelog/2026-01-05.json": "xvYq",
	"./zh-tw/changelog/2026-01-22.json": "Bn4Z",
	"./zh-tw/common/1_introduce.json": "+Vb3",
	"./zh-tw/common/api/permission/01_get_account_apiRestrictions.json": "l5cf",
	"./zh-tw/common/api/subAccount/01_create_sub_accuont.json": "Kq29",
	"./zh-tw/common/api/subAccount/02_get_account_apiPermission.json": "m+RL",
	"./zh-tw/common/api/subAccount/02_post_fetch_uid.json": "MZqr",
	"./zh-tw/common/api/subAccount/03_post_fetch_sub_account_list.json": "pZuE",
	"./zh-tw/common/api/subAccount/04_get_sub_account_spot_balance.json": "a8qg",
	"./zh-tw/common/api/subAccount/05_create_sub_accuont_key.json": "sYD+",
	"./zh-tw/common/api/subAccount/06_get_api_key_info.json": "azxt",
	"./zh-tw/common/api/subAccount/07_post_edit_apikey.json": "o4h9",
	"./zh-tw/common/api/subAccount/08_delete_sub_account_key.json": "lRf0",
	"./zh-tw/common/api/subAccount/09_update_sub_account_status.json": "K/yH",
	"./zh-tw/common/api/subAccount/10.post_wallet_authorize_innerTransfer.json": "JAIK",
	"./zh-tw/common/api/subAccount/11.post_wallet_subInnerTransfer.json": "zbJw",
	"./zh-tw/common/api/subAccount/11_post_capital_innerTransfer_apply.json": "S1Mk",
	"./zh-tw/common/api/subAccount/12.post_wallet_createSubDepositAddress.json": "mmsx",
	"./zh-tw/common/api/subAccount/15.get_wallet_querySubDepositAddress.json": "mcEH",
	"./zh-tw/common/api/subAccount/16.get_wallet_querySubDepositRecords.json": "Iuwz",
	"./zh-tw/common/api/subAccount/17.get_wallet_querySubInnerTransferRecords.json": "yVRY",
	"./zh-tw/common/api/subAccount/18_query_sub_account_transfer_history.json": "yGUm",
	"./zh-tw/common/api/subAccount/19_sub_account_transfer_support_coin.json": "lU9A",
	"./zh-tw/common/api/subAccount/20_sub_account_transfer.json": "7zc5",
	"./zh-tw/common/api/subAccount/22_sub_account_allAccountBalance.json": "mYOy",
	"./zh-tw/copyTrade/1_introduce.json": "Le/y",
	"./zh-tw/copyTrade/api/pFuturesTrader/01_get_currentTrack.json": "0uty",
	"./zh-tw/copyTrade/api/pFuturesTrader/02_post_close_currentTrack.json": "6Kq+",
	"./zh-tw/copyTrade/api/pFuturesTrader/03_post_tpsl_currentTrack.json": "Aoay",
	"./zh-tw/copyTrade/api/pFuturesTrader/05_swap_trader_detail.json": "t/o3",
	"./zh-tw/copyTrade/api/pFuturesTrader/06_swap_trader_profit_summary.json": "C/st",
	"./zh-tw/copyTrade/api/pFuturesTrader/07_swap_trader_profit_detail.json": "F3OC",
	"./zh-tw/copyTrade/api/pFuturesTrader/08_swap_trader_set_commission.json": "Dog/",
	"./zh-tw/copyTrade/api/pFuturesTrader/09_swap_trader_trading_pair.json": "Sp22",
	"./zh-tw/copyTrade/api/spotTrader/04_spot_trader_sell_order.json": "ByM2",
	"./zh-tw/copyTrade/api/spotTrader/10_spot_trader_detail.json": "jHm3",
	"./zh-tw/copyTrade/api/spotTrader/11_spot_trader_profit_summary.json": "ZPIr",
	"./zh-tw/copyTrade/api/spotTrader/12_spot_trader_profit_detail.json": "r/nZ",
	"./zh-tw/copyTrade/api/spotTrader/13_spot_trader_order_history.json": "CsM4",
	"./zh-tw/cswap/1_introduce.json": "2yPl",
	"./zh-tw/cswap/2_description.json": "ihU3",
	"./zh-tw/cswap/api/basic/01_error_code.json": "XCkz",
	"./zh-tw/cswap/api/basic/02_timestamp.json": "oPkH",
	"./zh-tw/cswap/api/basic/03_digital_rule.json": "WihS",
	"./zh-tw/cswap/api/basic/04_rate_limits.json": "p+dP",
	"./zh-tw/cswap/api/basic/05_system_time.json": "lC7j",
	"./zh-tw/cswap/api/market/01_get_contracts.json": "mCcU",
	"./zh-tw/cswap/api/market/02_get_premiumIndex.json": "nco7",
	"./zh-tw/cswap/api/market/03_get_openInterest.json": "pnyN",
	"./zh-tw/cswap/api/market/04_get_kline.json": "Yskp",
	"./zh-tw/cswap/api/market/05_get_depth.json": "2qcG",
	"./zh-tw/cswap/api/market/06_get_ticker.json": "PaEN",
	"./zh-tw/cswap/api/trade/00_post_trade_order.json": "YI4R",
	"./zh-tw/cswap/api/trade/01_get_commissionRate.json": "n+yS",
	"./zh-tw/cswap/api/trade/02_get_leverage.json": "bFqw",
	"./zh-tw/cswap/api/trade/03_post_leverage.json": "N7P3",
	"./zh-tw/cswap/api/trade/04_post_allOpenOrders.json": "0Lu1",
	"./zh-tw/cswap/api/trade/05_post_closeAllPositions.json": "vDcD",
	"./zh-tw/cswap/api/trade/06_get_positions.json": "+oba",
	"./zh-tw/cswap/api/trade/07_get_balance.json": "ptJe",
	"./zh-tw/cswap/api/trade/08_get_forceOrders.json": "D/10",
	"./zh-tw/cswap/api/trade/09_get_allFillOrders.json": "f4x/",
	"./zh-tw/cswap/api/trade/10_delete_trade_order.json": "01Ul",
	"./zh-tw/cswap/api/trade/11_get_all_openOrders.json": "TzVG",
	"./zh-tw/cswap/api/trade/12_get_trade_order.json": "c76v",
	"./zh-tw/cswap/api/trade/14_get_trade_allOrders.json": "I2ee",
	"./zh-tw/cswap/api/trade/15_get_margin_type.json": "qPGu",
	"./zh-tw/cswap/api/trade/16_post_margin_type.json": "LawJ",
	"./zh-tw/cswap/api/trade/17_post_trade_positionMargin.json": "eN7O",
	"./zh-tw/cswap/websocket/account/01_balance.json": "qHKX",
	"./zh-tw/cswap/websocket/account/02_order.json": "tdP1",
	"./zh-tw/cswap/websocket/account/03_setting.json": "PEUY",
	"./zh-tw/cswap/websocket/introduce/01_connect.json": "3tXb",
	"./zh-tw/cswap/websocket/introduce/02_data_compress.json": "CVyP",
	"./zh-tw/cswap/websocket/introduce/03_heart_beat.json": "vR2M",
	"./zh-tw/cswap/websocket/introduce/04_subscribe.json": "UYWd",
	"./zh-tw/cswap/websocket/introduce/05_cancel_subscribe.json": "2xEp",
	"./zh-tw/cswap/websocket/market/01_trade_info.json": "m2cs",
	"./zh-tw/cswap/websocket/market/02_last_price.json": "ntfQ",
	"./zh-tw/cswap/websocket/market/03_mark_price.json": "D6bT",
	"./zh-tw/cswap/websocket/market/04_depth.json": "pvqc",
	"./zh-tw/cswap/websocket/market/05_bookTicker.json": "exCQ",
	"./zh-tw/cswap/websocket/market/06_kline.json": "p1RX",
	"./zh-tw/cswap/websocket/market/07_24hr_ticker.json": "5LXd",
	"./zh-tw/listenKey/01_create_listenKey.json": "KCrj",
	"./zh-tw/listenKey/02_put_listenKey.json": "lKnG",
	"./zh-tw/listenKey/03_delete_listenKey.json": "+Xv4",
	"./zh-tw/q&a/2023-09-12.json": "Sd/4",
	"./zh-tw/spot/1_introduce.json": "z74M",
	"./zh-tw/spot/api/account/00_get_account_balance.json": "hIqz",
	"./zh-tw/spot/api/account/02_get_asset_transfer2.json": "ah5Z",
	"./zh-tw/spot/api/account/07_post_capital_innerTransfer_apply.json": "iYO+",
	"./zh-tw/spot/api/account/08_post_asset_transfer_new.json": "Oo3f",
	"./zh-tw/spot/api/account/09_get_account_transfer_support_coin.json": "QJQq",
	"./zh-tw/spot/api/account/10_get_asset_transfer_record.json": "fqje",
	"./zh-tw/spot/api/account/11_get_fund_account_balance.json": "dOYV",
	"./zh-tw/spot/api/account/14.get_wallet_queryInnerTransferRecords.json": "Jtu9",
	"./zh-tw/spot/api/account/21_get_account_allAccountBalance.json": "9SLF",
	"./zh-tw/spot/api/basic/01_server_url.json": "FVkd",
	"./zh-tw/spot/api/basic/03_error_code.json": "uv3h",
	"./zh-tw/spot/api/basic/04_rate_limits.json": "XvOK",
	"./zh-tw/spot/api/basic/04_server_url.json": "w7yn",
	"./zh-tw/spot/api/market/01_get_common_symbols.json": "o8W7",
	"./zh-tw/spot/api/market/02_get_ market_traders.json": "SDL0",
	"./zh-tw/spot/api/market/03_get_market_depth.json": "2qJV",
	"./zh-tw/spot/api/market/04_get_market_klines.json": "/lsz",
	"./zh-tw/spot/api/market/05_get_quote_ticker.json": "wj44",
	"./zh-tw/spot/api/market/06_get_market_agg_depth.json": "cYhj",
	"./zh-tw/spot/api/market/07_get_market_price.json": "ymfm",
	"./zh-tw/spot/api/market/08_get_market_book_ticker.json": "Tbeq",
	"./zh-tw/spot/api/market/09_get_market_history_klines.json": "7UNC",
	"./zh-tw/spot/api/market/10_get_ market_histroy_traders.json": "cRRp",
	"./zh-tw/spot/api/trade/01_post_trade_aorder.json": "MZay",
	"./zh-tw/spot/api/trade/01_post_trade_batchOrders.json": "jKsK",
	"./zh-tw/spot/api/trade/021_post_trade_order_cancel.json": "l/8P",
	"./zh-tw/spot/api/trade/022_post_trade_orders_cancel.json": "uDFu",
	"./zh-tw/spot/api/trade/023_post_cancelOpenOrders.json": "BdSn",
	"./zh-tw/spot/api/trade/023_post_trade_order_cancel_replace.json": "qru4",
	"./zh-tw/spot/api/trade/03_get_trade_order.json": "/YEw",
	"./zh-tw/spot/api/trade/04_get_trade_open_order.json": "bfDi",
	"./zh-tw/spot/api/trade/05_get_trade_history_order.json": "dcc+",
	"./zh-tw/spot/api/trade/077_get_trade_fill_details.json": "ui1J",
	"./zh-tw/spot/api/trade/08_get_commissionRate.json": "OkZ/",
	"./zh-tw/spot/api/trade/09_cancel_all_after.json": "IW4y",
	"./zh-tw/spot/api/trade/100_post_one_oco_order.json": "0DXm",
	"./zh-tw/spot/api/trade/101_cancel_one_oco_order.json": "cfpy",
	"./zh-tw/spot/api/trade/102_get_one_oco_order.json": "bM6w",
	"./zh-tw/spot/api/trade/103_get_all_pending_oco_order.json": "EsEh",
	"./zh-tw/spot/api/trade/104_get_all_history_oco_order.json": "bjJG",
	"./zh-tw/spot/api/wallet/03_get_deposit_hisrec.json": "ZlbJ",
	"./zh-tw/spot/api/wallet/04_get_withdraw_history.json": "DNed",
	"./zh-tw/spot/api/wallet/05_post_wallets_coins.json": "BYvq",
	"./zh-tw/spot/api/wallet/06_post_wallets_withdraw.json": "yxdj",
	"./zh-tw/spot/api/wallet/13.get_wallet_queryDepositAddress.json": "WnFl",
	"./zh-tw/spot/api/wallet/14_get_risk_deposit_records.json": "JbVL",
	"./zh-tw/spot/websocket/account/01_executionReport.json": "H6dO",
	"./zh-tw/spot/websocket/account/02_ account_update.json": "bZVt",
	"./zh-tw/spot/websocket/introduce/01_limit.json": "WMCK",
	"./zh-tw/spot/websocket/introduce/02_connect.json": "Jf00",
	"./zh-tw/spot/websocket/introduce/03_data_compress.json": "eQk0",
	"./zh-tw/spot/websocket/introduce/04_heart_beat.json": "nCmZ",
	"./zh-tw/spot/websocket/introduce/05_subscribe.json": "D11h",
	"./zh-tw/spot/websocket/introduce/06_cancel_subscribe.json": "8PHc",
	"./zh-tw/spot/websocket/market/01_trade_info.json": "tk7z",
	"./zh-tw/spot/websocket/market/02_kline_data.json": "klxE",
	"./zh-tw/spot/websocket/market/03_depth_info.json": "ADmP",
	"./zh-tw/spot/websocket/market/04_24hr_ticker.json": "7Biw",
	"./zh-tw/spot/websocket/market/05_last_price.json": "q1yk",
	"./zh-tw/spot/websocket/market/06_book_ticker.json": "vVRe",
	"./zh-tw/spot/websocket/market/07_depth_incr_info.json": "MY8u",
	"./zh-tw/standard/1_introduce.json": "okpR",
	"./zh-tw/standard/api/trade/01_get_contract_allPosition.json": "IW/r",
	"./zh-tw/standard/api/trade/02_get_contract_allOrders.json": "y5ws",
	"./zh-tw/standard/api/trade/03_get_contract_balance.json": "smla",
	"./zh-tw/swapV2/1_introduce.json": "5GrR",
	"./zh-tw/swapV2/2_description.json": "n5PB",
	"./zh-tw/swapV2/api/account/01_get_user_balance.json": "zKw2",
	"./zh-tw/swapV2/api/account/02_get_user_positions.json": "uAAZ",
	"./zh-tw/swapV2/api/account/03_get_user_income.json": "clol",
	"./zh-tw/swapV2/api/account/18_get_trade_income_export.json": "tvLy",
	"./zh-tw/swapV2/api/account/19_get_trade_user_commissionRate.json": "IIQZ",
	"./zh-tw/swapV2/api/basic/01_error_code.json": "INR5",
	"./zh-tw/swapV2/api/basic/02_timestamp.json": "gE9e",
	"./zh-tw/swapV2/api/basic/03_digital_rule.json": "v0HI",
	"./zh-tw/swapV2/api/basic/04_rate_limits.json": "x6dl",
	"./zh-tw/swapV2/api/basic/05_system_time.json": "i6gS",
	"./zh-tw/swapV2/api/market/01_get_quote_contracts.json": "lrAs",
	"./zh-tw/swapV2/api/market/03_get_quote_depth.json": "obcS",
	"./zh-tw/swapV2/api/market/04_get_quote_ trades.json": "KY9U",
	"./zh-tw/swapV2/api/market/05_get_quote_ premiumIndex.json": "5xUh",
	"./zh-tw/swapV2/api/market/06_get_quote_ fundingRate.json": "dEdI",
	"./zh-tw/swapV2/api/market/07_get_quote_ klines.json": "UTAD",
	"./zh-tw/swapV2/api/market/08_get_quote_openInterest.json": "0IKX",
	"./zh-tw/swapV2/api/market/09_get_quote_ ticker.json": "Y7KR",
	"./zh-tw/swapV2/api/market/19_get_historicalTrades.json": "iQjo",
	"./zh-tw/swapV2/api/market/20_get_trade_quote_bookTicker.json": "1iLz",
	"./zh-tw/swapV2/api/market/21_get_quote_mark_price_klines.json": "5vst",
	"./zh-tw/swapV2/api/market/22_get_quote_price_v2.json": "OSRE",
	"./zh-tw/swapV2/api/market/23_get_trading_rules.json": "gkT4",
	"./zh-tw/swapV2/api/trade/00_post_trade_order_test.json": "CwX9",
	"./zh-tw/swapV2/api/trade/01_post_trade_order.json": "vDBD",
	"./zh-tw/swapV2/api/trade/01_post_trade_order_vst.json": "6dPc",
	"./zh-tw/swapV2/api/trade/02_post_edit_order.json": "vwLZ",
	"./zh-tw/swapV2/api/trade/02_post_trade_batch_order.json": "Crrt",
	"./zh-tw/swapV2/api/trade/03_post_closeAllPositions.json": "pKuc",
	"./zh-tw/swapV2/api/trade/04_delete_trade_order.json": "9V8o",
	"./zh-tw/swapV2/api/trade/05_delete_trade_batch_order.json": "hIfT",
	"./zh-tw/swapV2/api/trade/06_delete_trade_all_order.json": "Nw8z",
	"./zh-tw/swapV2/api/trade/07_get_all_openOrders.json": "Ewmn",
	"./zh-tw/swapV2/api/trade/08_check_pending_order.json": "26Si",
	"./zh-tw/swapV2/api/trade/08_get_trade_order.json": "/1k/",
	"./zh-tw/swapV2/api/trade/09_get_trade_marginType.json": "7mzI",
	"./zh-tw/swapV2/api/trade/10_post_trade_marginType.json": "WVbz",
	"./zh-tw/swapV2/api/trade/11_get_trade_leverage.json": "/Kh3",
	"./zh-tw/swapV2/api/trade/12_post_trade_leverage.json": "ZoHP",
	"./zh-tw/swapV2/api/trade/13_get_trade_forceOrders.json": "9bR8",
	"./zh-tw/swapV2/api/trade/14_get_trade_allOrders.json": "7bgg",
	"./zh-tw/swapV2/api/trade/15_post_trade_positionMargin.json": "QHIT",
	"./zh-tw/swapV2/api/trade/17_get_trade_allFillOrders.json": "7iFh",
	"./zh-tw/swapV2/api/trade/18_set_positionSide.json": "QEfH",
	"./zh-tw/swapV2/api/trade/19_get_positionSide.json": "jzOs",
	"./zh-tw/swapV2/api/trade/20_cancel_replace_order.json": "4bTX",
	"./zh-tw/swapV2/api/trade/21_batch_cancel_replace_order.json": "/nLp",
	"./zh-tw/swapV2/api/trade/22_cancel_all_after.json": "1pQ9",
	"./zh-tw/swapV2/api/trade/22_post_closePosition.json": "/qZT",
	"./zh-tw/swapV2/api/trade/23_get_trade_allOrdersV2.json": "iRbd",
	"./zh-tw/swapV2/api/trade/24_get_maint_margin_ratio.json": "OyBm",
	"./zh-tw/swapV2/api/trade/25_get_fill_history_detail.json": "PJcf",
	"./zh-tw/swapV2/api/trade/26_get_user_position_history.json": "sWA2",
	"./zh-tw/swapV2/api/trade/27_get_position_margin_history.json": "5iQm",
	"./zh-tw/swapV2/api/trade/27_post_get_vst.json": "dtEQ",
	"./zh-tw/swapV2/api/trade/28_post_twap_order.json": "50Mv",
	"./zh-tw/swapV2/api/trade/29_get_twap_open_orders.json": "0L6n",
	"./zh-tw/swapV2/api/trade/30_get_twap_history_orders.json": "srGS",
	"./zh-tw/swapV2/api/trade/31_get_twap_order_detail.json": "+xXY",
	"./zh-tw/swapV2/api/trade/32_cancel_twap_order.json": "5pjb",
	"./zh-tw/swapV2/api/trade/33_post_asset_mode.json": "thBV",
	"./zh-tw/swapV2/api/trade/34_get_asset_mode.json": "cRAY",
	"./zh-tw/swapV2/api/trade/35_get_multi_asset_rule.json": "EWHP",
	"./zh-tw/swapV2/api/trade/36_get_margin_asset.json": "/HCz",
	"./zh-tw/swapV2/api/trade/37_post_trade_reverse.json": "NBWN",
	"./zh-tw/swapV2/api/trade/38_post_auto_add_margin.json": "FDO9",
	"./zh-tw/swapV2/websocket/account/01_listenKey.json": "jg15",
	"./zh-tw/swapV2/websocket/account/02_balance.json": "W9nQ",
	"./zh-tw/swapV2/websocket/account/03_order.json": "/xkA",
	"./zh-tw/swapV2/websocket/account/04_setting.json": "pHnt",
	"./zh-tw/swapV2/websocket/introduce/00_limit.json": "u2Il",
	"./zh-tw/swapV2/websocket/introduce/01_connect.json": "uUP9",
	"./zh-tw/swapV2/websocket/introduce/02_data_compress.json": "ku8a",
	"./zh-tw/swapV2/websocket/introduce/03_heart_beat.json": "QDPd",
	"./zh-tw/swapV2/websocket/introduce/04_subscribe.json": "f4mz",
	"./zh-tw/swapV2/websocket/introduce/05_cancel_subscribe.json": "IhWV",
	"./zh-tw/swapV2/websocket/market/01_dept_info_interval.json": "bP1Q",
	"./zh-tw/swapV2/websocket/market/02_latest_records.json": "cRtg",
	"./zh-tw/swapV2/websocket/market/03_kline_data.json": "WbRb",
	"./zh-tw/swapV2/websocket/market/04_quote_ticker.json": "AAve",
	"./zh-tw/swapV2/websocket/market/05_last_trade_price.json": "lqZR",
	"./zh-tw/swapV2/websocket/market/06_last_mark_price.json": "zVt3",
	"./zh-tw/swapV2/websocket/market/07_book_ticker.json": "5TRZ",
	"./zh-tw/swapV2/websocket/market/08_depth_incr_info.json": "PEl6"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zQIm";


//////////////////
// WEBPACK FOOTER
// ./src/config \.json$
// module id = zQIm
// module chunks = 3